import { render, staticRenderFns } from "./ImportSupplyPrice.vue?vue&type=template&id=1907b030&scoped=true"
import script from "./ImportSupplyPrice.vue?vue&type=script&lang=js"
export * from "./ImportSupplyPrice.vue?vue&type=script&lang=js"
import style0 from "./ImportSupplyPrice.vue?vue&type=style&index=0&id=1907b030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907b030",
  null
  
)

export default component.exports